module.exports = __webpack_public_path__ + "static/media/insta.b2aa37d3.png";